import moment from 'moment';

const StringUtils = {};

StringUtils.truncateText = function (str, length) {
  if (str.length <= length) {
    return str;
  }

  var truncated = str.substr(0, length).replace(/[^A-Za-z][A-Za-z]*$/, '...');
  if (truncated.lastIndexOf('...') !== truncated.length - 3) {
    truncated += '...';
  }

  return truncated;
};

StringUtils.trim = function (str) {
  if (!String.prototype.trim) {
    return str.replace(/(^\s+|\s+$)/g, '');
  }

  return str.trim();
};

StringUtils.formatTimestampForDrawerConversation = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay: 'h:mma', // -> 4:03pm
    lastDay: '[Yesterday]', // -> Yesterday
    lastWeek: 'MMM D', // -> Jan 9
    sameElse: 'MMM D', // -> Jan 9
  });
};

StringUtils.formatTimestampForMessageListSeperator = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay: '[Today]', // -> Today
    lastDay: '[Yesterday]', // -> Yesterday
    lastWeek: 'dddd', // -> Tuesday
    sameElse: 'MMMM D, YYYY', // -> January 16, 2017
  });
};

StringUtils.formatTimestampMessengerWindows = function (timestamp) {
  const now = moment();
  const then = moment(timestamp);

  if (now.diff(then, 'seconds') < 10) {
    return 'just now';
  } else if (now.diff(then, 'seconds') < 60) {
    return `${now.diff(then, 'seconds')}s`;
  } else if (now.diff(then, 'minutes') < 60) {
    return `${now.diff(then, 'minutes')}m`;
  } else if (now.diff(then, 'hours') < 24) {
    return `${now.diff(then, 'hours')}h`;
  }

  return moment(timestamp).calendar(null, {
    lastDay: '[Yesterday]', // -> Yesterday
    lastWeek: 'MMM D', // -> Jan 16
    sameElse: 'MMM D', // -> Jan 16
  });
};

export default StringUtils;
